import React from 'react'
import { VideoThumbnail } from './VideoThumbnail'

export const Video = ({ url, showPreview }: { url: string, showPreview: boolean }): JSX.Element => {
  return <VideoThumbnail videoUrl={url} showPreview={showPreview} />
}
